import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import shared from "../../assets/locale/En/shared";
import { TextField, Typography, Rating } from "@mui/material";
import { fetchSurveyRequest } from "../../store/Survey/actions";
import { YellowStarFilled, YellowStarLine } from "../../utils/Icons";
import PropTypes from "prop-types";
import EmptyState from "../EmptyState";
import eventPlaceholder from "../../assets/images/event-screen/events-placeholder.svg";
import messages from "../../assets/locale/messages";
import "./surveyForm.scss";
import {clientScoreAttributeKeys} from "../../utils/Constants";

const AdminSurveyForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.lang);
  const { clientSatisfaction } = messages[lang];

  const { data } = useSelector((state) => state.surveyReducer);

  useEffect(() => {
    dispatch(fetchSurveyRequest(id));
  }, [dispatch]);


  return (
    <>
      {!data || data?.data?.length == 0 ? (
        <div className="d-flex justify-content-center w-100">
          <EmptyState
            description={shared.scoreNotFound}
            imgSrc={eventPlaceholder}
            showActionButton={false}
          />
        </div>
      ) : (
        <div className="grid-container h-auto">
          {data.data[0]?.attributes_data?.map((attr_data, key) => (
            <div className="grid-item" key={key}>
              <Typography variant="h6">
                <span className="count">{key + 1}</span>
                {clientSatisfaction.criteria[
                  clientScoreAttributeKeys[attr_data?.attribute_name]
                ] ?? attr_data?.attribute_name}
              </Typography>

              <Typography>{clientSatisfaction.score.important}</Typography>
              <h1>{attr_data?.importance}/5</h1>

              <Typography>{clientSatisfaction.score.score}</Typography>
              <Rating
                readOnly
                name="serviceQualityScore"
                value={attr_data?.rating}
                max={5}
                icon={<YellowStarFilled />}
                emptyIcon={<YellowStarLine />}
              />
            </div>
          ))}
        </div>
      )}

      {!data || data?.data?.length === 0 ? null : (
        <>
          {/* Total Score */}
          <div className="total-score-wrapper">
            <div className="title">
              <Typography className={`${lang === "en" ? "fs-3" : "fs-4 mt-2" }`} variant="h6">{clientSatisfaction.score.total}</Typography>
            </div>
            <div className="score">
              <span>{clientSatisfaction.score.score}</span>
              <Typography variant="h6">
                {data?.data[0]?.score_percentage}%
              </Typography>
            </div>
          </div>
          {/* Suggestions/Comments */}
          <div className="suggestion-comments-wrapper">
            <div className="title">
              <Typography variant="h5">{clientSatisfaction.score.suggestionsComments}</Typography>
            </div>
            <TextField
              label={clientSatisfaction.placeholders.writeDescription}
              name="suggestions"
              value={data.data[0]?.comments}
              disabled={true}
              fullWidth
              multiline
              rows={4}
              InputLabelProps={{
                style: {
                  textAlign: lang === "en" ? "left" : "right",
                  position: "absolute",
                  left: "0",
                },
                shrink: true,
              }}
              margin="normal"
            />
          </div>
        </>
      )}
    </>
  );
};
AdminSurveyForm.propTypes = {
  adminclientClassifiction: PropTypes.bool.isRequired,
};
export default AdminSurveyForm;
